import { POOL_FILL_CRIT, POOL_FILL_WARN } from './consts'
import { PoolFillPoint } from './types'

export type PoolFillSeries = {
  red: (number | null)[]
  yellow: (number | null)[]
  green: (number | null)[]
  used: (number | null)[]
  withoutDisputes: (number | null)[]
}

const round1 = (v: number) => Math.round(v * 10) / 10
const capped = (v: number | null, cap: number) => (v === null ? null : Math.min(v, cap))

// Заливка по высоте без стека (стек у Apex сложил бы и линии): три непрозрачные
// области рисуются сзади наперёд — красная до значения, жёлтая до 80, зелёная
// до 60 — и каждая перекрывает нижнюю часть предыдущей. null — разрыв во всех.
export function buildPoolFillSeries(points: PoolFillPoint[]): PoolFillSeries {
  const used = points.map((p) => (p.pct === null ? null : round1(p.pct)))
  return {
    red: used,
    yellow: used.map((v) => capped(v, POOL_FILL_CRIT)),
    green: used.map((v) => capped(v, POOL_FILL_WARN)),
    used,
    withoutDisputes: points.map((p) =>
      p.pct_without_disputes === null ? null : round1(p.pct_without_disputes)
    ),
  }
}
